import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center pt-20 pb-16 px-6 overflow-hidden bg-dark" data-id="element-63">
      {/* Background subtle glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-64"></div>

      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-65">
        <div className="text-center lg:text-left" data-id="element-66">
          <FadeIn data-id="element-67">
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl leading-tight mb-6 text-cream" data-id="element-68">
              Capture Every Moment of Your Event —{' '}
              <span className="text-gold italic" data-id="element-69">In One Place</span>
            </h1>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-70">
            <p className="text-lg md:text-xl text-cream-dark/80 mb-10 max-w-2xl mx-auto lg:mx-0 font-light leading-relaxed" data-id="element-71">
              Your guests take hundreds of photos… but you never see them.
              TapShare changes that — instantly.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-72">
            <div className="flex items-center gap-3 mb-4 justify-center lg:justify-start" data-id="element-73">
              <span className="text-cream-dark/50 line-through text-xl" data-id="element-74">
                $120
              </span>
              <span className="text-gold font-heading text-4xl font-bold" data-id="element-75">
                $79
              </span>
              <span className="bg-gold/20 text-gold text-sm font-semibold px-3 py-1 rounded-full" data-id="element-76">
                SAVE 34%
              </span>
            </div>
            <Button className="text-lg w-full sm:w-auto" data-id="element-77">
              👉 Get Yours Now
            </Button>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} direction="left" className="relative" data-id="element-78">
          <div className="relative rounded-2xl overflow-hidden shadow-[0_0_40px_rgba(201,168,76,0.15)] border border-gold/20" data-id="element-79">
            <div className="absolute inset-0 bg-gradient-to-t from-dark/80 via-transparent to-transparent z-10" data-id="element-80"></div>
            <img src="https://cdn.magicpatterns.com/uploads/cyLafr5YNZbaWTKRV6DcDc/babyshowerprod2.png" alt="TapShare baby shower sign with phone showing gallery" className="w-full h-auto object-cover transform hover:scale-105 transition-transform duration-700" data-id="element-81" />
          </div>
          {/* Decorative elements */}
          <div className="absolute -top-4 -right-4 w-24 h-24 border-t-2 border-r-2 border-gold/30 rounded-tr-3xl" data-id="element-82"></div>
          <div className="absolute -bottom-4 -left-4 w-24 h-24 border-b-2 border-l-2 border-gold/30 rounded-bl-3xl" data-id="element-83"></div>
        </FadeIn>
      </div>
    </section>;
}